<!-- eslint-disable -->
<div class="eca-monotron-description-wrapper">
  <p class="eca-monotron-description">
    Please carefully review this document’s alerts and update or confirm as necessary to clear the alerts.
    Note that Score Input errors must be corrected in the answer document and rescanned.
    Once all alerts have been cleared, the document will move to the Submit tab.
  </p>
</div>

<div class="filter-bar"
  [formGroup]="form">

  <div class="button-group">
    <button mat-button
      color="secondary"
      routerLink="/scan">
      Rescan
    </button>
    <button mat-button
      color="primary"
      [disabled]="hasUnsubmittableAlerts$ | async"
      ecaThrottleClick
      (throttleClick)="showConfirmation()">
      Clear All Alerts
    </button>
  </div>
</div>

<div class="review-groups">

  <eca-alerts-review-table [data]="alerts$ | async"
    (view)="selectAlert($event)">
  </eca-alerts-review-table>

  @if (!(hasOnlySubmitAlerts$ | async)) {
    <eca-alerts-image-viewer
      [regions]="regions$ | async"
      [src]="imageSrc$ | async"
      [showNoData]="hasOnlyBiographicAlerts$ | async"
      (loadedImage)="imageLoaded()">
    </eca-alerts-image-viewer>
  }

  @else {
    <eca-submit-error></eca-submit-error>
  }

</div>
